import { gql } from '@apollo/client';

export const CREATE_CURRICULUM_MUTATION = gql`
    mutation createCurriculum($input: CurriculumInput!) {
        result: createCurriculum(input: $input) {
            id
            locales {
                locale
                name
                description
            }
            courses {
                edges {
                    node {
                        id
                        locales {
                            locale
                            name
                            description
                        }
                    }
                }
            }
            isPublic
            tags
            isSequential
        }
    }
`;

// input CurriculumInput {
//     id: UUID!
//     locales: [CurriculumLocaleInput!]!
//     isPublic: Boolean
//     isSequential: Boolean
//     heroImageId: UUID
//     bannerImageId: UUID
//     thumbnailImageId: UUID
//     tags: [String!]
//     courseIds: [UUID!]
//     segmentIds: [UUID!]
// }
